import * as Yup from "yup";

export const planSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  insurer: Yup.string().required("Campo requerido"),
  code: Yup.string().required("Campo requerido"),
  amount: Yup.number().required("Campo requerido"),
});
